


























import AbpBase from "@/lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '@/lib/util'
import {
    GetBindingLaboratoryIndicatorsList,
    GetLaboratoryIndicatorsList,
    GetAllIndicator,
    SaveBindingLaboratoryIndicator
} from "@/api/laboratoryCategories";
@Component({})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    form:any = {}
    title="";
    async created() {
        if(this.data.saveType=="编辑"){
            this.title=this.data.itemName+ "编辑";
            this.form = Object.assign({},this.data);
        }
        else if(this.data.saveType=="批量添加")
        {
            this.title=this.data.itemName+"批量添加";
            this.form = this.data;
        }
        else
        {
            this.form = Object.assign({},this.data);
            this.title=this.data.itemName+ "编辑";
        }
    }
    async save(){
        if(this.data.id){
            (this.$refs.form as any).validate(async (valid:boolean)=>{
                if(valid){
                    let res = await SaveBindingLaboratoryIndicator(this.form)
                    if(res.status==1){
                        this.$emit('input',false);
                        this.$emit('on-success')
                    }
                }
            })
        }
        else 
        {
            this.data.conversion = this.form.conversion;
            this.data.valueType = this.form.valueType;
            this.$Message.success("操作成功");
            this.$emit('input',false);
            this.$emit('on-success')
        }
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/editBindingIndicators.vue